"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = exports.NAME = void 0;
exports.NAME = "@accurx/shared";
exports.VERSION = "8.3.8";
//# sourceMappingURL=PackageDetails.js.map